






























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { formatNumber } from '@/utils/helpers'
import CartList from './CartList.vue'
import FoodDetail from './FoodDetail.vue'
import PosOrderModal from '@/components/PosOrderModal.vue'
import api from '@/api'
import { findOttoReceipt } from '@/utils/ottoPay'
import constants from '@/utils/constants'

@Component({
  components: {
    CartList,
    FoodDetail,
    PosOrderModal
  },
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    }
  }
})
export default class PosOrderResult extends Vue {
  $swal: any
  public status: number = 1 // 1: pending, 2: success, 3: expired
  public loading: boolean = false
  public posOrderPath: string =
    sessionStorage.getItem('pos-order-page') || '/pos-order'
  public data: any = JSON.parse(sessionStorage.getItem('cartListInfo') || '{}')
  public tableNo: string = sessionStorage.getItem('table_no') || '{}'
  public sessionOrderType: string = sessionStorage.getItem('order_type') || ''
  public orderType: string = ''
  public hour: string = '00'
  public min: string = '00'
  public sec: string = '00'
  public checkCode: string = ''
  public createdDate: string = ''
  public totalSales: string = ''
  public outletName: string = sessionStorage.getItem('outletName') || ''
  public timer: any = null
  public orderId: string = sessionStorage.getItem('orderId') || ''
  public showPosOrderPopup: boolean = false
  public posOrderId: string = ''

  get isEDC() {
    return this.$store.state.isEDC
  }

  get isEDCOfflinePayment() {
    return (
      this.data &&
      !!constants.EDC_OFFLINE_PAYMENT_OPTIONS.find(
        item => item.value === this.data.selectedPayment.text
      )
    )
  }

  posOrderPopup(value) {
    this.showPosOrderPopup = value
  }

  posOrderValue(value) {
    this.posOrderId = value
  }

  printHandle() {
    const UserName = localStorage.getItem('UserName')
    const isOttoPay = this.data.payment_method === 'ottopay-h2h'
    const report: Promise<any> = isOttoPay
      ? api.GetAllOrderReport({ page: 1, size: 50 }, { orderId: this.orderId, outletCode: '', orderType: '', orderStatus: [], cancelStatus: [], createdAt: { startDate: '', endDate: '' } })
      : this.$store.dispatch('GetAllOrderReport')
    report.then(res => {
      const rows = (res && res.data && res.data.data) || []
      const order = isOttoPay ? findOttoReceipt(rows, this.orderId) : rows[0]
      if (!order) { this.$swal(constants.SOMETHING_WROING, 'The receipt for this bill is not available yet. Please retry.', constants.STATUS_ERROR); return }

      if (window && typeof (window as any).android !== 'undefined') {
        (window as any).android.printBill(
          JSON.stringify(order),
          UserName
        );
        (window as any).android.printBill(
          JSON.stringify(order),
          UserName,
          0,
          0
        )
      }
    }).catch(() => {
      this.$swal(constants.SOMETHING_WROING, 'Could not load the receipt for this bill. Please retry.', constants.STATUS_ERROR)
    })
  }

  mounted() {
    const sessionPayCallBackInfo = sessionStorage.getItem('payCallBackInfo')
    if (sessionPayCallBackInfo) {
      let payCallBackInfo = JSON.parse(sessionPayCallBackInfo)
      const { checkCode, createdDate, totalSales } = payCallBackInfo
      this.checkCode = checkCode
      this.createdDate = createdDate
      this.totalSales = totalSales
    }
    if (this.data.payment_method === 'ottopay-h2h') { this.reloadPage(''); return; }
    if (this.data.isFree || this.data.payment === 'Cash') {
      this.status = 2
    } else {
      this.reloadPage('')
    }
    const sessionLLeftTime = sessionStorage.getItem('leftTime')
      ? Number(sessionStorage.getItem('leftTime'))
      : 2 * 10 * 60000
    const endDate = new Date(new Date().getTime() + sessionLLeftTime)
    const countTime = () => {
      clearTimeout(this.timer)
      const date = new Date()
      const now = date.getTime()
      const end = endDate.getTime()
      const leftTime = end - now
      let h, m, s, ms
      if (leftTime >= 0) {
        h = Math.floor(leftTime / 1000 / 60 / 60)
        m = Math.floor((leftTime / 1000 / 60) % 60)
        s = Math.floor((leftTime / 1000) % 60)
        ms = Math.floor(leftTime % 1000)
        if (ms < 100) {
          ms = '0' + ms
        }
        if (s < 10) {
          s = '0' + s
        }
        if (m < 10) {
          m = '0' + m
        }
        if (h < 10) {
          h = '0' + h
        }
        sessionStorage.setItem('leftTime', String(leftTime))
      } else {
        clearTimeout(this.timer)
        this.status = 3
        return
      }
      this.hour = h
      this.min = m
      this.sec = s
      this.timer = setTimeout(countTime, 1000)
    }
    const timeout = sessionStorage.getItem('timeout')
    if (timeout) {
      this.status = 3
    } else {
      countTime()
    }
    switch (this.sessionOrderType) {
      case 'table-order':
        this.orderType = 'Table Order'
        break
      case 'dine-in':
        this.orderType = 'Dine In'
        break
      case 'take-away':
        this.orderType = 'Takeaway'
        break
      default:
        this.orderType = constants.OTHERS
        break
    }
  }

  @Watch('status')
  watchStatus() {
    if (this.status === 2 || this.status === 3) {
      clearTimeout(this.timer)
    }
  }

  reloadPage(notMounted) {
    if (notMounted) {
      this.loading = true
    }
    let paymentMethod
    if (this.data.payment === 'Astrapay') {
      paymentMethod = 'Astrapay'
    } else {
      paymentMethod = this.data.payment_method
    }
    api.GetPosOrderStatus({ orderId: this.orderId }, paymentMethod).then(res => {
      this.loading = false
      try {
        const status = res.data.data.status
        if (status === constants.UPPER_CANCELLED) {
          return (this.status = 3)
        }
        if (
          status === 'PAYMENT_SUCCESS' ||
          status === 'TRANSFERRED' ||
          status === 'COMPLETED'
        ) {
          return (this.status = 2)
        }
        // call cimb qr notify with android
        if (status === 'INIT' && this.data.selectedPayment.text === 'CIMB-QR') {
          const sessionPayCallBackInfo = sessionStorage.getItem('payCallBackInfo')
          if (sessionPayCallBackInfo) {
            let payCallBackInfo = JSON.parse(sessionPayCallBackInfo)
            const { orderId, referenceId } = payCallBackInfo
            console.log('payCallBackInfo', payCallBackInfo)
            if (orderId === this.orderId) {
              if (window && typeof (window as any).android !== 'undefined') {
                (window as any).android.notificationQRPayWithCimbApp(
                  orderId,
                  referenceId
                )
              }
            }
          }
        }
      } catch (error) {
        throw error
      }
    })
  }

  switchPage(page, tomenu?: any) {
    clearTimeout(this.timer)
    const isPos = sessionStorage.getItem('isPos')
    if (page === this.posOrderPath && isPos) {
      sessionStorage.removeItem('isPos')
      sessionStorage.removeItem('leftTime')
      return this.$router.push(page)
    }
    if (page === '/pos-qr') {
      if (this.data.payment_method === 'ottopay-h2h' || constants.QR_TYPE.includes(this.data.payment)) {
        this.$router.push(page)
      } else {
        this.$router.push(
          sessionStorage.getItem('pos-order-page') || '/pos-order'
        )
      }
      return
    }
    if (page.includes('/pos-order') && !tomenu) {
      sessionStorage.setItem('showCart', '1')
    }
    if (page.includes('/pos-order') && tomenu) {
      sessionStorage.removeItem('timeout')
      sessionStorage.removeItem('showCart')
      sessionStorage.removeItem('qrCode')
      sessionStorage.removeItem('payCallBackInfo')
      sessionStorage.removeItem('orderId')
      sessionStorage.removeItem('cartListInfo')
    }
    this.$router.push(page)
  }

  hanldeKembali(handler: () => void) {
    handler()
    sessionStorage.setItem('clicked_kembali', '1')
  }
}
